//two-factor
export const ModalOneData = [
    {
      icon: "fa-spin fa-cog",
      title: "2FA Authenticator",
      description: "Obtain codes from a authy/google authenticator/ios 15 etc.",
    },
    {
      icon: "fa-comments",
      title: "SMS",
      description: "The backup login method will be sent to you via SMS if you require it.",
    },
  ];
  
//Form Wizard 1
export const NumberingWizardSubTitle = [{ text: "Fill up your details and proceed next steps." }];

export const StepperHorizontalData = ["Basic Info", "Cart Info", "Feedback", "Finish"];

export const StudentValidationFormSubTitle = [{ text: "Please make sure fill all the filed before click on next button." }];

export const VerticalValidationWizardSubTitle = [{ text: "Fill up your true details and next proceed." }];

export const VerticalWizardNavData = [
  {
    id: 1,
    icon: "user",
    title: "Your Info",
    subTitle: "Add your details",
  },
  {
    id: 2,
    icon: "chain-broken",
    title: "Cart Info",
    subTitle: "Add your a/c details",
  },
  {
    id: 3,
    icon: "group",
    title: "Net Banking",
    subTitle: "Choose your bank",
  },
];

export const PaymentModeName = ["Visa", "MasterCard", "paypal"];

export const NetBankingFormBankList = [
  { id: 1, bankList: ["Industrial & Commercial Bank", "Agricultural Bank", "JPMorgan Chase & Co."] },
  { id: 2, bankList: ["Construction Bank Corp.", "Bank of America", "HDFC Bank"] },
];

export const ShippingFormSubTitle = [{ text: "Fill up your true details and next proceed." }];

export const ShippingFormNavData = [
  {
    id: 1,
    icon: "user",
    title: "Billing",
  },
  {
    id: 2,
    icon: "truck",
    title: "Shipping",
  },
  {
    id: 3,
    icon: "money",
    title: "Payment",
  },
  {
    id: 4,
    icon: "check-square",
    title: "Finish",
  },
];

export const CurrentCartTableFooterData = [
  { footerTittle: "Sub Total :", price: "1284.00" },
  { footerTittle: "Discount :", price: "20.00" },
  { footerTittle: "Shipping Charge :", price: "100.78" },
  { footerTittle: "Tax :", price: "205.34" },
  { footerTittle: "Total (USD) :", price: "1569.7" },
];

export const CurrentCartTableBodyData = [
  {
    imagePath: "product/13.png",
    productName: "T-shirt",
    productSum: "$98 * 2",
    price: "$400",
  },
  {
    imagePath: "email-template/4.png",
    productName: "Headphone",
    productSum: "$4*2",
    price: "$450",
  },
  {
    imagePath: "product/2.png",
    productName: "T-shirt ",
    productSum: "$10*2",
    price: "$234",
  },
  {
    imagePath: "product/10.png",
    productName: "Chairs ",
    productSum: "$98*2",
    price: "$200",
  },
];

export const CountryData = ["Select Country", "Africa", "India", "Indonesia", "Netherlands", "U.K", "U.S"];

export const HomeAndOfficeAddressData = [
  {
    value: "shipping-choose1",
    label: "Home",
    name: "Filomena Green ",
    adress: "2211 Fruitville Rd, Sarasota, Florida, US 34237",
    contact: "(941) 321-5643",
  },
  {
    value: "shipping-choose2",
    label: "Work",
    name: "Ms. Ila Runte DDS",
    adress: " 1531 E 23rd St S, Independence, Mississippi, US 64055",
    contact: "(816) 252-4500",
    check: "checked",
  },
];

export const ShippingMethodsData = [
  {
    value: "standardDelivery",
    label: "Standard Delivery - Free",
    details: "Estimated 5-7 days shipping",
  },
  {
    value: "expressDelivery",
    label: "Express Delivery - $24",
    details: "Estimated 1-2 days shipping",
    check: "checked",
  },
];

//form wizard 2
export const CustomNavData = [
  { id: 1, icon: "user", title: "Personal info" },
  { id: 2, icon: "chain-broken", title: "Connect bank account" },
  { id: 3, icon: "group", title: "Inquiries" },
  { icon: "group", title: "Completed " },
];

export const PopularBanksList = [
  { image: "hdfc.png", bankName: "ABC BANK" },
  { image: "Bank-of-Baroda.png", bankName: "XYZ BANK" },
  { image: "idbi.png", bankName: "PQR BANK" },
  { image: "rbl.png", bankName: "DEF BANK" },
  { image: "us-bank.png", bankName: "MNO BANK" },
  { image: "axis.png", bankName: "WXY BANK" },
  { image: "SCB.png", bankName: "STD BANK" },
];

export const ItemsNameList = ["Featured Items", "Newsletters", "Notifications", "Blogs"];

export const BusinessNavData = [{ id: 1, title: "Choose account" }, { id: 2, title: "Business settings" }, { id: 3, title: "Contact details" }, { id: 4, title: "Pay details" }, { title: "completed" }];

export const SelectAccountTypeData = [
  { icon: "university", title: "Business" },
  { icon: "user", title: "Personal " },
];

export const ListOfYears: number[] = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035];

export const VariationBoxData = [
  { title: "Tivo", details: "2-3 Members" },
  { title: "Berlin", details: "4-5 Members" },
  { title: "Roxo", details: "2 Member" },
  { title: "Boho", details: "1 Member" },
];
